import { render } from "./AddParticipant.vue?vue&type=template&id=ace2ebc2&scoped=true"
import script from "./AddParticipant.vue?vue&type=script&lang=js"
export * from "./AddParticipant.vue?vue&type=script&lang=js"

import "./AddParticipant.vue?vue&type=style&index=0&id=ace2ebc2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ace2ebc2"]])

export default __exports__